import { RegistrationState } from "./RegistrationState";
import { RegStateValidate } from "./RegStateValidate";

/** Etat : Traitement d'un token d'activation */
export class RegStateActivation extends RegistrationState{
    public async Next(): Promise<void> {
        /** Initialisation des messages affichés */
        this.context.Title = this.context.$t('ActivationTitle').toString();
        this.context.FirstExplainLine = this.context.$t('ActivationFirstExplainLine').toString();
        this.context.SecondExplainLine = "";
        this.context.SubmitText = this.context.$t('ActivationSubmitText').toString();
        this.context.ShowLogin = false;


        /** Initialisation des messages affichés */
        this.context.ValidateTitle = this.context.$t('ValidateTitleActivation').toString();
        this.context.ValidateSuccessMessage = this.context.$t('ValidateSuccessActivation').toString();
        this.context.ValidateFailMessage = this.context.$t('ValidateFailActivationExpired').toString();

        /** Intialisation des champs de saisie */
        this.context.Login = this.analyseToken.Login ;
        this.context.Password = "";
        this.context.TransitionTo(new RegStateValidate(this))
    }
}